import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=91aa4ad8"
import script from "./contract.vue?vue&type=script&lang=js"
export * from "./contract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91aa4ad8')) {
      api.createRecord('91aa4ad8', component.options)
    } else {
      api.reload('91aa4ad8', component.options)
    }
    module.hot.accept("./contract.vue?vue&type=template&id=91aa4ad8", function () {
      api.rerender('91aa4ad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/contract/contract/contract.vue"
export default component.exports